import {KeyTextField} from '@prismicio/client'
import {
  PricingSectionSliceDefaultPrimaryFirstPackageItem,
  PricingSectionSliceReskinPrimaryFirstPackageItem,
  PricingSectionSlice,
} from 'prismicio-types'
import cn from 'classnames'
import {ModuleCard} from './ModuleCard'

type PackageSectionProps = {
  title: KeyTextField
  modules: PricingSectionSliceDefaultPrimaryFirstPackageItem[] | PricingSectionSliceReskinPrimaryFirstPackageItem[]
  variation: PricingSectionSlice['variation']
  enableContainer?: boolean
}

export const PackageSection = ({title, modules, variation, enableContainer}: PackageSectionProps) => {
  return (
    <div
      className={cn('col-span-full flex flex-col gap-4 lg:grid lg:grid-cols-subgrid', {
        'lg:col-span-3': modules.length === 1,
        'lg:col-span-6': modules.length === 2,
        'lg:col-span-9': modules.length === 3,
        'lg:col-span-full': modules.length === 4,
      })}
    >
      <span
        className={cn('text-body-xs uppercase lg:col-span-full', {
          'text-body-xs': variation !== 'reskin',
          'text-button-s leading-4 text-grey-550': variation === 'reskin',
        })}
      >
        {title}
      </span>
      <div className="flex flex-col gap-4 lg:col-span-full lg:row-start-2 lg:grid lg:grid-cols-subgrid lg:gap-6">
        {modules.map((module, index) => (
          <ModuleCard
            {...module}
            key={module.module_title! + index}
            variation={variation}
            iconContainer={enableContainer && variation === 'reskin'}
          />
        ))}
      </div>
    </div>
  )
}
